"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validatePropertyRepair = exports.propertyRepairSchema = void 0;
/* eslint-disable camelcase */
var schema_validator_1 = require("@hobt/schema-validator");
var constants_1 = require("../../constants");
exports.propertyRepairSchema = {
    type: 'object',
    required: ['amount', 'borrowerChargeCode', 'cmhcLoanAccountNumber', 'offlineApprovalIndicator'],
    properties: {
        amount: {
            type: 'number',
            maximum: 9999999999999,
            minimum: -9999999999999,
            decimal: [15, 2],
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision',
        },
        borrowerChargeCode: {
            type: 'string',
            enum: [constants_1.BorrowerChargesCode.PropertyRepairs],
            errorMessage: 'Should equate to a valid BorrowerChargesCode propertyRepair enum value',
        },
        cmhcLoanAccountNumber: {
            type: 'number',
            maximum: 99999999,
            minimum: 1000000,
            errorMessage: 'should be numeric between 1000000 to 99999999',
        },
        approvalRemovedTimestamp: {
            type: ['string', 'null'],
            pattern: '^(\\d{4}-\\d{2}-\\d{2})(-| )(\\d{2})(:|.)(\\d{2})(:|.)(\\d{2})(.)(\\d{1,6})$',
            errorMessage: 'Should have date-time format YYYY-MM-DD 00:00:00.000000, YYYY-MM-DD 00.00.00.000000, YYYY-MM-DD-00.00.00.000000',
        },
        offlineApprovalIndicator: {
            type: 'boolean',
            errorMessage: 'should be either true or false',
        },
        offlineApprovalTimestamp: {
            type: ['string', 'null'],
            pattern: '^(\\d{4}-\\d{2}-\\d{2})(-| )(\\d{2})(:|.)(\\d{2})(:|.)(\\d{2})(.)(\\d{1,6})$',
            errorMessage: 'Should have date-time format YYYY-MM-DD 00:00:00.000000, YYYY-MM-DD 00.00.00.000000, YYYY-MM-DD-00.00.00.000000',
        },
    },
};
exports.validatePropertyRepair = function (data, addAuditFields) {
    if (addAuditFields === void 0) { addAuditFields = false; }
    var propertyRepairValidator = new schema_validator_1.SchemaValidator(exports.propertyRepairSchema, true, true, true, true);
    if (addAuditFields) {
        propertyRepairValidator.extendSchema(schema_validator_1.auditFieldsSchema);
    }
    return propertyRepairValidator.validate(data);
};
